import { jsx } from 'react/jsx-runtime';
import { useMemo } from 'react';
import classNames from 'classnames';
import { IconBrandList, Icon } from '../../Icon/Icon.es.js';
import { IconCircle } from '../../Icon/Icon.Circle/Icon.Circle.es.js';
import { useHeadingContext } from '../Heading.Context/index.es.js';

const HeadingIcon = ({ iconName, status = 'info', loop = false })=>{
    const { size, type } = useHeadingContext();
    const isBrandIcon = useMemo(()=>IconBrandList.includes(iconName), [
        iconName
    ]);
    const iconSizing = useMemo(()=>{
        if (type === 'page' && [
            'lg',
            'md'
        ].includes(size) || type === 'section' && [
            'lg',
            'md'
        ].includes(size)) {
            return {
                className: 'large',
                size: 58,
                iconSize: 'large'
            };
        } else if (type === 'page' && size === 'sm' || type === 'title' && [
            'lg',
            'md'
        ].includes(size)) {
            return {
                className: 'medium',
                size: 48,
                iconSize: 'default'
            };
        } else {
            return {
                className: 'small',
                size: 32,
                iconSize: 'small'
            };
        }
    }, [
        size,
        type
    ]);
    return isBrandIcon ? jsx(Icon, {
        className: classNames('cb-heading-icon', {
            loop
        }),
        name: iconName,
        size: iconSizing.size
    }) : jsx(IconCircle, {
        className: classNames('cb-heading-icon icon-circle', iconSizing.className, status, {
            loop
        }),
        name: iconName,
        size: iconSizing.iconSize
    });
};
HeadingIcon.displayName = 'Heading.Icon';

export { HeadingIcon };
//# sourceMappingURL=Heading.Icon.es.js.map
